import { createRouter, createWebHistory } from 'vue-router'
import { ElLoading } from 'element-plus';
import HelloWorld from '../page/HelloWorld.vue'

const routes = [
    // 路由默认跳转
    {
        path: '/:pathMatch(.*)*',
        redirect: '/404'
    },
    {
        path: '/404',
        component: () => import('../page/NotFound.vue'),
        meta: { title: '404' }
    },
    {
        path: '/',
        component: HelloWorld,
        meta: { title: 'Home' }
    },
    {
        path: '/description',
        component: () => import('../page/Project/DescriptionPage.vue'),
        meta: { title: 'Description' }
    },
    {
        path: '/design',
        component: () => import('../page/Project/Design.vue'),
        meta: { title: 'Design' }
    },
    {
        path: '/futurework',
        component: () => import('../page/Project/FutureWork.vue'),
        meta: { title: 'FutureWork' }
    },
    {
        path: '/contribution',
        component: () => import('../page/Project/Contribution.vue'),
        meta: { title: 'Contribution' }
    },
    {
        path: '/implementation',
        component: () => import('../page/Project/Implementation.vue'),
        meta: { title: 'Implementation' }
    },
    {
        path: '/proof-of-concept',
        component: () => import('../page/Project/ProofofConcept.vue'),
        meta: { title: 'Proof of Concept' }
    },
    {
        path: '/concept',
        component: () => import('../page/WetLab/Concept.vue'),
        meta: { title: 'Concept' }
    },
    {
        path: '/engineering',
        component: () => import('../page/WetLab/Engineering.vue'),
        meta: { title: 'Engineering' }
    },
    {
        path: '/notebook',
        component: () => import('../page/WetLab/Notebook.vue'),
        meta: { title: 'Notebook' }
    },
    {
        path: '/protocol',
        component: () => import('../page/WetLab/Protocol.vue'),
        meta: { title: 'Protocol' }
    },
    {
        path: '/results',
        component: () => import('../page/WetLab/Results.vue'),
        meta: { title: 'Results' }
    },
    {
        path: '/parts',
        component: () => import('../page/WetLab/Parts.vue'),
        meta: { title: 'Parts' }
    },
    {
        path: '/safety',
        component: () => import('../page/Safety.vue'),
        meta: { title: 'Safety' }
    },
    {
        path: '/model',
        component: () => import('../page/Model.vue'),
        meta: { title: 'Model' }
    },
    {
        path: '/entrepreneurship',
        component: () => import('../page/HP/Entrepreneurship.vue'),
        meta: { title: 'Entrepreneurship' }
    },
    {
        path: '/human-practices',
        component: () => import('../page/HP/IntegratedHumanPractice.vue'),
        meta: { title: 'Integrated Human Practice' }
    },
    {
        path: '/education',
        component: () => import('../page/HP/Education.vue'),
        meta: { title: 'Education' }
    },
    {
        path: '/attributions',
        component: () => import('../page/Team/Attributions.vue'),
        meta: { title: 'Attributions' }
    },
    {
        path: '/team',
        component: () => import('../page/Team/Roster.vue'),
        meta: { title: 'Engineering' }
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(_to, _from, _savedPosition) {
        return { top: 0, left: 0 }
    }
})

let loadingInstance;

router.beforeEach((to, from, next) => {
    loadingInstance = ElLoading.service({
        lock: true,
        text: 'Loading...',
        background: '#F9F8EA',
    })
    window.document.title = to.meta.title + ' | Tongji-China - iGEM -2024';
    next();
    setTimeout(() => {
        loadingInstance.close();
    }, 2000)

});

export default router